module.exports = __webpack_public_path__ + "img/ico_light.c451f4f8.svg";